<template>
  <GlassCard class="col-20 mb-5 py-3 login-glass-card">
    <!-- Rows  -->
    <!-- :class="template.secondaryTheme ? 'bg-red-300' : 'bg-blue-300'"  -->

    <div :class="!template.cardTitle && !authorize ? 'mt-n3' : 'mt-4'" class="row pt-2 m-2">
      <!-- Title -->
      <div
        v-if="template.ssoCardTitle || template.cardTitle"
        class="col-sm-12 col-md-12 form-group text-left pb-0 mb-0"
      >
        <p :style="template.secondaryTheme ? 'color: white;' : ''" class="login-title text-center">
          {{ authorize ? template.ssoCardTitle : template.cardTitle }}<br />
        </p>
      </div>

      <section v-if="!sessionToken" class="col-12 px-0">
        <!-- Login with only CPF or Email -->
        <div v-if="!config.noFanBoxLogin">
          <div
            v-if="!config.alternativeLoginObj"
            class="col-sm-12 col-md-12 text-left form-group mt-2"
          >
            <!-- CPF -->
            <input
              v-if="isCpfLoginField"
              type="email"
              id="email"
              v-model="userLogin"
              class="w-100"
              :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
              :placeholder="loginOptionPlaceholder"
              tabindex="-1"
              v-mask="vTipe"
              @keydown.enter="authorize ? AuthorizeV2() : Login()"
            />
            <input
              v-else
              type="email"
              id="email"
              v-model="userLogin"
              class="w-100"
              :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
              :placeholder="loginOptionPlaceholder"
              tabindex="-1"
              @keydown.enter="authorize ? AuthorizeV2() : Login()"
            />

            <span
              v-if="showAlternateLoginToggle"
              class="input-show-pass mt-2 mr-4"
              style="font-size: x-small"
              @click="alternateLogin"
            >
              {{ alternativeLoginTooltipText }}
            </span>
          </div>

          <!-- Login with options in template -->
          <div
            v-else
            class="col-sm-12 col-md-12 text-left form-group mt-2 login-alternate-options"
            style="display: flex; align-items: center; justify-content: space-between"
          >
            <!-- CPF -->
            <input
              v-if="config.loginType == 1 && !alternativeLogin"
              type="email"
              id="email"
              v-model="userLogin"
              :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
              style="width: 74%"
              :placeholder="$t('login.cpf')"
              tabindex="-1"
              v-mask="vTipe"
              @keydown.enter="authorize ? AuthorizeV2() : Login()"
            />
            <input
              v-else
              type="email"
              id="email"
              :placeholder="alternativeNumberName"
              v-model="userLogin"
              :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
              tabindex="-1"
              v-mask="alternativeNumberMask"
              style="width: 74%"
              @keydown.enter="authorize ? AuthorizeV2() : Login()"
            />

            <div
              class="login-with-label"
              :style="
                template.secondaryTheme ? 'color: white; font-size: 0.85rem; padding-top:4px;' : ''
              "
              style="display: block; margin-top: -25px; margin-left: 14px"
            >
              {{ ownerId == 121 ? $t('login.loginWith') : $t('login.logWith') }}

              <br />

              <select
                v-model="alternativeNumber"
                :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
                class="text-sm"
              >
                <option
                  v-for="(value, name) in config.alternativeLoginObj"
                  :value="value.Type"
                  :key="name"
                  style="color: black"
                >
                  {{ name }}
                </option>
              </select>
            </div>
          </div>

          <!-- Password -->
          <div class="col form-group text-left mt-2">
            <input
              v-model="password"
              id="pass"
              class="w-100"
              :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
              :type="showPassword ? 'text' : 'password'"
              :placeholder="$t('login.password')"
              @keyup.enter="
                authorize
                  ? AuthorizeV2()
                  : ownerId == 121 || ownerId == 54 || ownerId == 169
                  ? //? executeRecaptcha()
                    Login()
                  : null
              "
            />

            <span class="input-show-pass mt-2 mr-4" @click="showPassword = !showPassword">
              <i class="fa fa-eye senhaIcon" :class="showPassword ? 'fa-eye' : 'fa-eye-slash'" />
            </span>
          </div>

          <!-- Error -->
          <div class="col-sm-12 col-md-12 text-left">
            <vs-alert v-if="errors.length" class="mb-1 mt-2" color="#ffffff" :active="inputInvalid">
              <b
                :style="ownerId == 23 ? 'color: #fcff45;' : 'color: #ff637e;'"
                style="font-size: 10px"
              >
                {{ $t('common.please') }}

                <span
                  v-for="error in errors"
                  :key="error.questid"
                  :style="ownerId == 23 ? 'color: #fcff45;' : 'color: #ff637e;'"
                >
                  {{ error.msg }}
                </span>
              </b>
            </vs-alert>
          </div>

          <!-- Login Btn -->
          <div class="col-sm-12 col-md-12 form-group mt-3">
            <div v-if="loginBtnLoader" class="text-center">
              <LoadingRing />
            </div>
            <div v-else>
              <button
                v-if="authorize || returnToSurvey"
                class="btn btn-block btn-black shadow-sm"
                type="submit"
                :style="primaryBtnStyle"
                @click="AuthorizeV2"
              >
                {{ template.primaryBtn.text }}
              </button>
              <button
                v-else
                class="btn btn-block btn-black shadow-sm"
                type="submit"
                :style="primaryBtnStyle"
                @click="Login"
                @keyup.enter="Login"
              >
                {{ template.primaryBtn.text }}
              </button>

              <button
                v-if="template.thirdPartyAuthBtn"
                :id="template.thirdPartyAuthBtn.id"
                :class="[
                  'btn btn-block shadow-sm',
                  'd-flex align-items-center justify-content-center fw-bold',
                ]"
                :style="{
                  background: template.thirdPartyAuthBtn.bgColor,
                  color: template.thirdPartyAuthBtn.textColor,
                  borderColor: template.thirdPartyAuthBtn.borderColor,
                }"
                @click="() => openAuthLink(template.thirdPartyAuthBtn.redirectUrl)"
              >
                <span>{{ template.thirdPartyAuthBtn.text }}</span>

                <img
                  v-if="
                    template.thirdPartyAuthBtn.logo && template.thirdPartyAuthBtn.logo.length > 0
                  "
                  :src="template.thirdPartyAuthBtn.logo"
                  :alt="template.thirdPartyAuthBtn.id"
                  class="h-auto object-contain position-relative ml-1"
                  :style="{
                    width: template.thirdPartyAuthBtn.logoWidth,
                    transform: 'translateY(-0.15rem)',
                  }"
                />
              </button>
            </div>
          </div>

          <!-- Redefine Password -->
          <div
            :style="
              config.modeVisitor
                ? 'margin-bottom: 10px;'
                : !template.secondaryBtn.text
                ? 'margin-bottom: 50px;'
                : ''
            "
            class="col-md-12 col-sm-12 d-flex justify-content-center"
          >
            <router-link
              to="Recuperar"
              tag="button"
              class="small text-white bg-transparent textDecoration"
              style="border: none"
            >
              {{ $t('login.forgotPassword') }}
            </router-link>
          </div>

          <!-- Divider -->
          <div v-if="!config.modeVisitor && template.secondaryBtn.text" class="col-sm-12 col-md-12">
            <div class="row d-flex justify-content-center my-3 align-items-center">
              <div class="col-3">
                <hr style="border-color: white" />
              </div>

              <small
                class="mb-0 text-center"
                :style="template.secondaryTheme ? 'color:white;' : ''"
              >
                {{ $t('login.noAccountYet') }}
              </small>

              <div class="col-3">
                <hr style="border-color: white" />
              </div>
            </div>
          </div>

          <!-- Create Account -->
          <div
            v-if="!config.modeVisitor && template.secondaryBtn.text"
            class="col-sm-12 col-md-12"
            style="margin-bottom: 40px"
          >
            <button
              class="btn-block btn-dark btn shadow-sm"
              :class="template.secondaryTheme ? 'font-weight-medium' : ''"
              style="padding: 5px 0; font-size: small; letter-spacing: 1px; font-weight: 600"
              :style="secondaryBtnStyle"
              @click="gotoCadastro"
            >
              {{
                template.secondaryBtn.text ? template.secondaryBtn.text : $t('login.createAccount')
              }}
            </button>
          </div>
        </div>

        <div v-for="(item, index) in config.externalSSO" :key="index">
          <MicrosoftSSO v-if="item.name === 'Microsoft'" @user-is-signed="check2FAAuthentication" />
        </div>

        <div v-if="template.internalFooterLogin" class="col-sm-12 col-md-12 form-group">
          <div
            v-if="template.internalFooterLogin.logo"
            style="width: 100%; display: flex; justify-content: center; align-items: center"
          >
            <p
              style="font-size: 0.8rem; padding-top: 20px; margin-right: 5px"
              v-if="template.internalFooterLogin.poweredText"
            >
              Powered By
            </p>

            <img
              :src="template.internalFooterLogin.logo"
              :width="template.internalFooterLogin.logowith"
            />
          </div>

          <div
            v-if="template.internalFooterLogin.showPoweredBy"
            style="
              height: 30px;
              margin-top: 5px;
              width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <div class="py-5">
              <small style="color: white; font-size: 0.55rem; text-transform: uppercase">
                Powered by
              </small>

              <img
                class="ml-1"
                src="https://config.fanbase.com.br/prj/0/logo-white.png"
                width="45px"
              />
            </div>
          </div>

          <!-- <div
            v-if="template.internalFooterLogin.description"
            style="
              height: 30px;
              margin-top: 10px;
              width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <div style="width: 300px">
              <p
                style="
                  color: white;
                  font-size: 0.5rem;
                  font-weigth: 100;
                  line-height: 1.2 !important;
                  text-align: center;
                "
              >
                {{ template.internalFooterLogin.description }}
              </p>
            </div>
          </div> -->
        </div>
      </section>

      <!-- If token is in LocalStorage -->
      <section v-else class="col-12 text-center">
        <LoadingRing />
      </section>
    </div>
  </GlassCard>
</template>

<script>
/* Directives */
import { mask } from 'vue-the-mask'

import axios from 'axios'

/* State */
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

/* Services */
import { loginFB } from '@/services/ServFB.js'
import { loginV2 } from '@/services/LoginV2.js'

import MicrosoftSSO from './MicrosoftSSO.vue'

const lFB = new loginFB()
const lv2 = new loginV2()

export default {
  name: 'Home',
  components: { MicrosoftSSO },
  directives: {
    mask,
  },
  props: {
    authorize: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    RECAPTCHA_SITE_KEY: '6LcofpIqAAAAAKky8UC58kx31mbd1VM35oC-KZHb',
    errors: [],
    recaptchaError: false,
    userLogin: '',
    password: '',
    id: null,
    prjName: '',
    obj: null,
    counter: '',
    msg: '',
    alternativeLogin: false,
    vTipe: '###.###.###-##',
    showPassword: false,
    tk: '',
    params: {},
    sessionToken: null,
    method2FA: null,
    alternativeNumber: null,
    alternativeNumberName: null,
    alternativeNumberMask: null,
    loginBtnLoader: null,
    resendOptions: null,
    clientId: null,
  }),
  watch: {
    authorize(newValue) {
      if (newValue) this.$store.commit('set_sso', newValue)
    },

    config: {
      handler() {
        if (this.config.alternativeLoginObj) {
          this.alternativeNumber = this.config.loginType
        }
        if (this.emailOnlyLoginWithIso3) {
          this.alternativeLogin = false
        }
        this.executeSessionPipeline()
      },
      deep: true,
    },

    oidcParams: {
      handler() {
        this.executeSessionPipeline()
      },
      deep: true,
    },

    alternativeNumber(newValue) {
      if (this.config.alternativeLoginObj) {
        for (const [key, value] of Object.entries(this.config.alternativeLoginObj)) {
          if (value.Type === newValue) {
            this.alternativeNumberName = key

            if (value.Mask) {
              this.alternativeNumberMask = value.Mask
            } else {
              this.alternativeNumberMask = null
            }
          }
        }

        if (parseInt(newValue) != this.config.loginType) {
          this.alternativeLogin = true
        } else {
          this.alternativeLogin = false
        }
      }
    },
  },
  computed: {
    ...mapGetters(['primaryBtnStyle', 'secondaryBtnStyle', 'primaryColorText']),
    ...mapState([
      'template',
      'config',
      'subdomain',
      'oidcParams',
      'loginByRegistration',
      'registrationObject',
    ]),

    returnToSurvey() {
      const urlParams = new URLSearchParams(window.location.search)
      return urlParams.has('returnTo')
    },

    ownerId() {
      return this.config.ownerId
    },

    emailOnlyLoginWithIso3() {
      return (
        Number(this.config.loginType) === 4 &&
        this.config.iso3 &&
        String(this.config.iso3).trim() !== ''
      )
    },

    showAlternateLoginToggle() {
      return !this.emailOnlyLoginWithIso3
    },

    isCpfLoginField() {
      if (this.emailOnlyLoginWithIso3) return false

      const type = Number(this.config.loginType)

      if (!this.alternativeLogin) return type === 1
      return type !== 1
    },

    alternativeLoginTooltipText() {
      if (this.config.loginType == 1 && !this.alternativeLogin) {
        return this.$t('login.switchToEmail')
      }

      if (this.config.loginType == 1 && this.alternativeLogin) {
        return this.$t('login.switchToCpf')
      }

      if (this.config.loginType == 4 && !this.alternativeLogin) {
        return this.$t('login.switchToCpf')
      }

      if (this.config.loginType == 4 && this.alternativeLogin) {
        return this.$t('login.switchToEmail')
      }
    },

    loginOptionPlaceholder() {
      const type = this.config.loginType

      if (!this.alternativeLogin) {
        if (Number(type) === 1) return this.$t('login.cpf')

        return this.$t('login.email')
      }

      if (Number(type) === 1) return this.$t('login.email')

      return this.$t('login.cpf')
    },
  },
  mounted() {
    this.updateRecaptchaBadgeVisibility(this.owner)

    const recaptchaScript = document.querySelector('script[src*="recaptcha"]')

    if (recaptchaScript) {
      if (window.grecaptcha) {
        this.onRecaptchaLoaded()
      } else {
        recaptchaScript.addEventListener('load', this.onRecaptchaLoaded)
      }
    }
  },
  beforeDestroy() {
    const recaptchaScript = document.querySelector('script[src*="recaptcha"]')
    if (recaptchaScript) {
      recaptchaScript.removeEventListener('load', this.onRecaptchaLoaded)
    }
  },
  methods: {
    ...mapMutations(['setOidcParams', 'setCopyLoginPayload']),
    ...mapActions(['validateOidcRequest']),

    ErrorOccured(value, id) {
      let payload = {
        questid: id,
        msg: value,
      }

      if (this.errors) {
        let found = false

        for (let i = 0; i < this.errors.length; i++) {
          if (this.errors[i].questid == id) {
            this.errors[i] = payload
            found = true
          }
        }

        if (!found) {
          this.errors.push(payload)
          this.qtErros++
        }
      } else {
        this.qtErros++
        this.errors.push(payload)
      }
    },

    executeRecaptcha() {
      try {
        if (!window.grecaptcha) {
          alert('grecaptcha não está carregado.')
          console.error('grecaptcha está indefinido.')
          return
        }

        window.grecaptcha
          .execute(this.RECAPTCHA_SITE_KEY, { action: 'submit' })
          .then(resp => {
            if (!resp) {
              console.error('Token inválido:', resp)
              return
            }
            this.validateRecaptcha(resp)
          })
          .catch(error => {
            alert('Erro ao executar o ReCAPTCHA')
            console.error('Erro no execute:', error)
          })
      } catch (error) {
        console.error('Erro inesperado:', error)
        this.recaptchaError = error
      }
    },

    updateRecaptchaBadgeVisibility() {
      const badge = document.querySelector('.grecaptcha-badge')
      if (!badge) return

      const showBadge = [121, 54].includes(this.config.ownerId)
      badge.style.display = showBadge ? 'block' : 'none'
    },

    onRecaptchaLoaded() {
      window.grecaptcha.ready(() => {
        this.updateRecaptchaBadgeVisibility()
      })
    },

    async validateRecaptcha(token) {
      const fanPageUrl = process.env.VUE_APP_FANPAGEDOMAIN

      try {
        const url = `${fanPageUrl}/api/Account/CheckRecaptchaLogin/${token}`

        const response = await axios.get(url)

        if (response.data.success) {
          this.Login()
        } else {
          this.recaptchaError = response.data['error-codes']
        }

        // recaptchaError.value = response.data['error-codes']
      } catch (error) {
        this.recaptchaError = error
      }
    },

    RemoveError(id) {
      if (this.errors)
        for (var i = 0; i < this.errors.length; i++) {
          if (this.errors[i].questid == id) {
            this.errors.splice(i, 1)
            this.qtErros--
          }
        }

      if (this.errors.length == 0) {
        this.errors = []
        this.qtErros = 0
      }
    },

    validateCredentials() {
      var ok = true

      this.errors = []

      if (!this.userLogin) {
        this.ErrorOccured('Informe seu usuário. ', 1)
        document.getElementById('email').focus()
        ok = false
      }

      if (!this.password) {
        ok = false
        this.ErrorOccured('Informe sua senha. ', 2)
        if (this.errors.length < 2) document.getElementById('pass').focus()
      }

      return ok
    },

    openAuthLink(url) {
      window.open(url, '_self')
    },

    alternateLogin() {
      this.alternativeLogin = !this.alternativeLogin
      this.userLogin = ''
    },

    containsHint() {
      if (Object.keys(this.oidcParams).length !== 0 && this.oidcParams.id_token_hint) return true
      return false
    },

    redirectErrorLoginRequired() {
      window.location.href = this.oidcParams.redirect_uri + '?error=login_required'
    },

    gotoCadastro() {
      const prj = this.subdomain

      this.$router.push({
        name: 'Cadastro',
        params: {
          prj,
        },
      })
    },

    makeToast(variant = null) {
      this.$bvToast.toast(this.msg, {
        title: `Error!`,
        variant: variant,
        solid: true,
      })
    },

    checkLocalStorageToken() {
      this.sessionToken = localStorage.getItem('session')
    },

    executeSessionPipeline() {
      this.checkLocalStorageToken()

      if (!this.sessionToken) {
        if (this.containsHint()) this.redirectErrorLoginRequired()
        return
      }

      let isValid = this.checkSessionValidity(this.sessionToken)
      if (!isValid) return

      if (this.authorize) {
        if (this.containsHint()) {
          this.AuthorizeV2()
        } else {
          this.sessionToken = ''
        }
      } else {
        this.loginBySession()
      }
    },

    async checkSessionValidity(sessionToken) {
      await lFB
        .CheckSessionValidity(sessionToken)
        .then(res => {
          if (!res) {
            localStorage.removeItem('session')
            this.sessionToken = ''
          }
          return res
        })
        .catch(err => alert(err))
    },

    oAuthAuthorize() {
      let loginInfo = {
        id: this.userLogin,
        password: this.password,
        loginType: parseInt(this.config.loginType),
        systemId: parseInt(this.config.systemID),
        prjId: parseInt(this.config.prj),
        ownerId: parseInt(this.config.ownerId),
        alternativeLogin: this.alternativeLogin,
        subDomainLogin: this.subdomain,
        alternativeNumber: this.alternativeNumber,
      }

      this.setCopyLoginPayload(loginInfo)

      if (this.validateCredentials()) {
        this.loginBtnLoader = true

        lFB.Authorize(loginInfo, this.oidcParams, null, this.config).then(
          data => {
            this.check2FAAuthentication(data)
          },
          err => {
            this.makeToast('danger')
            this.msg = err.message
            this.ErrorOccured(err, 3)
            this.loginBtnLoader = false
            if (err.includes('create-guardian')) {
              this.$router.push('/create-guardian')
            }
          },
        )
      }
    },

    redirectAfterLogin(url) {
      window.location.href = url
    },

    getRedirectUrl() {
      const params = new URLSearchParams(new URL(window.location.href).search)
      return params.get('redirect_uri')
    },

    AuthorizeV2() {
      let payload = {
        id: this.userLogin,
        password: this.password,
        loginType: parseInt(this.config.loginType),
        systemId: parseInt(this.config.systemID),
        prjId: parseInt(this.config.prj),
        ownerId: parseInt(this.config.ownerId),
        alternativeLogin: this.alternativeLogin,
        subDomainLogin: this.subdomain,
        alternativeNumber: this.alternativeNumber,
      }

      if (this.validateCredentials()) {
        this.loginBtnLoader = true

        lv2.loginv2(payload, this.config).then(
          data => {
            let URL = this.getRedirectUrl()

            switch (data.action) {
              case 'CODE':
                URL = URL + `?code=${data.actionData}`
                this.redirectAfterLogin(URL)
                break

              case 'DO2FA':
                this.$router.push({
                  name: 'TwoFactorsAuthV2',
                  params: { clientId: this.clientId, userLogin: this.userLogin },
                })
                break

              case 'REDIRECT':
                this.redirectAfterLogin(data.actionData)
                break

              default:
                console.warn('Condição de login não reconhecida:')
                break
            }
          },
          err => {
            this.makeToast('danger')
            this.msg = err
            this.ErrorOccured(err, 3)
            this.loginBtnLoader = false
          },
        )
      }
    },

    async check2FAAuthentication(info) {
      try {
        this.loginBtnLoader = true

        await lFB.get2FAData(this.clientId, info).then(
          data => {
            if (data.data.actionCode === 1) {
              this.method2FA = data.data.sentBy
              this.resendOptions = data.data.resendOptions.split(';')
            }
          },
          err => {
            this.makeToast('danger')
            this.msg = err
            this.loginBtnLoader = false
          },
        )
      } catch (err) {
        this.makeToast('danger')
        this.msg = err
        this.loginBtnLoader = false
      }

      if (!this.method2FA) {
        localStorage.setItem('session', info)
        lFB.GetRedirectUrl(info, this.config.modeVisitor, parseInt(this.config.systemID))
      } else {
        this.registrationObject.method2FA = this.method2FA
        this.registrationObject.sessionToken = info
        this.$router.push({
          name: 'TwoFactorsAuth',
          params: { resendOptions: this.resendOptions, clientId: this.clientId },
        })
      }
    },

    oAuthAuthorizeBySession() {
      let loginInfo = {
        id: this.sessionToken,
        password: '',
        loginType: parseInt(this.config.loginType),
        systemId: parseInt(this.config.systemID),
        prjId: parseInt(this.config.prj),
        ownerId: parseInt(this.config.ownerId),
        subDomainLogin: this.subdomain,
        IdToken: this.oidcParams.id_token_hint,
        alternativeNumber: this.alternativeNumber,
      }

      lFB.Authorize(loginInfo, this.oidcParams, true).then(
        data => {
          localStorage.setItem('session', data)
          this.sessionToken = data
          lFB.GetRedirectUrl(data)
        },
        err => {
          this.makeToast('danger')
          this.msg = err
          this.ErrorOccured(err, 3)
        },
      )
    },

    Login() {
      let obj = {
        id: this.userLogin,
        password: this.password,
        loginType: parseInt(this.config.loginType),
        systemId: parseInt(this.config.systemID),
        prjId: parseInt(this.config.prj),
        ownerId: parseInt(this.config.ownerId),
        alternativeLogin: this.alternativeLogin,
        subDomainLogin: this.subdomain,
        alternativeNumber: this.alternativeNumber,
      }

      if (this.validateCredentials()) {
        this.loginBtnLoader = true

        lFB.login(obj).then(
          data => {
            this.check2FAAuthentication(data)
          },
          err => {
            this.makeToast('danger')
            this.msg = err
            this.ErrorOccured(err, 3)
            this.loginBtnLoader = false
          },
        )
      }
    },

    loginBySession() {
      let obj = {
        id: this.sessionToken,
        password: this.password,
        loginType: parseInt(this.config.loginType),
        systemId: parseInt(this.config.systemID),
        prjId: parseInt(this.config.prj),
        ownerId: parseInt(this.config.ownerId),
        subDomainLogin: this.subdomain,
        alternativeNumber: this.alternativeNumber,
      }

      lFB.login(obj, true).then(
        data => {
          localStorage.setItem('session', data)
          this.sessionToken = data
          lFB.GetRedirectUrl(data)
        },
        err => {
          this.makeToast('danger')
          this.msg = err
          this.ErrorOccured(err, 3)
        },
      )
    },

    handleOidcParams() {
      if (Object.keys(this.oidcParams).length !== 0) return

      const urlSearchParams = new URLSearchParams(window.location.search)
      const params = Object.fromEntries(urlSearchParams.entries())

      if (params.session) localStorage.setItem('session', params.session)
      this.validateOidcRequest(params)
    },

    handleLoginByRegistration() {
      this.userLogin =
        this.config.loginType == 1 ? this.registrationObject.cpf : this.registrationObject.email

      this.password = this.registrationObject.password

      this.authorize ? this.AuthorizeV2() : this.Login()
    },
  },
  created() {
    this.alternativeNumber = this.config.loginType

    if (this.loginByRegistration) {
      this.handleLoginByRegistration()
    } else if (this.authorize) {
      this.$store.commit('set_sso', true)
      this.handleOidcParams()
    }

    this.clientId = this.$route.query.client_id ? this.$route.query.client_id : 'fanbox2'
  },
}
</script>

<style scoped>
@media (max-width: 767.98px) {
  .mobile {
    width: 200px;
  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  .mobile {
    width: 200px;
  }
}

.login-title {
  font-size: 1.15rem !important;
  line-height: 24px;
}

.bgBlack {
  background-color: black;
}

.btn-black {
  color: #fff;
  background-color: black;
  border-color: black;
}

.font-weight-medium {
  font-weight: bold;
  font-size: 1rem !important;
  letter-spacing: -0.5px !important;
}

.btn-black:hover {
  color: #fff;
  background-color: #23272b;
  border-color: #1d2124;
}

.backGround {
  background-size: cover;
  min-width: 340px;
}

.smaller {
  font-size: 70%;
}

.btnCustom {
  height: 48px;
  font-size: small;
  font-weight: 600;
  letter-spacing: 1px;
}

.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1000;
  top: 40%;
  left: 0px;
  opacity: 0.5;
  filter: alpha(opacity=50);
}

.fb {
  background-color: #3b5998;
  color: white;
  border-color: #3b5998;
}

.google {
  background-color: #dd4b39;
  border-color: #dd4b39;
  color: white;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #212529;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #212529 transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>

<style>
.form-control-sm {
  height: 48px;
}

.form-control::placeholder {
  font-size: 80%;
}

.btn {
  height: 48px;
}

.btn:focus {
  box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%) !important;
}

.login-glass-card .col-sm-12.mt-4 {
  margin-top: 1.5rem !important;
  padding-top: 0 !important;
}

.login-glass-card .img-fluid.rounded {
  margin-bottom: 24px !important;
}

.login-glass-card .row.pt-2 {
  padding-top: 0 !important;
}

.login-glass-card.custom-glass-card,
.login-glass-card.glass-card {
  min-width: 430px;
  max-width: 100%;
}

.login-alternate-options {
  flex-wrap: nowrap;
}

.login-with-label {
  flex-shrink: 0;
  white-space: nowrap;
}

@media (max-width: 499px) {
  .login-glass-card.custom-glass-card,
  .login-glass-card.glass-card {
    min-width: 0 !important;
    width: 100%;
    max-width: 100%;
  }
}
</style>
